import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { ParameterType } from 'src/app/interfaces/parameter'
import { PainelService } from 'src/app/services/painel.service'
import { ParametersService } from 'src/app/services/parameters.service'
import { SetoresService } from 'src/app/services/setores.service'
import { TotemPainelService } from 'src/app/services/totem-painel.service'
import { PainelType } from '../interfaces/painel'
import { TotemType } from '../interfaces/totem'
import { TotemPainelType } from '../interfaces/totemPainel'

@Component({
  selector: 'app-settings-totem',
  templateUrl: './settings-totem.component.html',
  styleUrls: ['./settings-totem.component.scss'],
})
export class SettingsTotemComponent implements OnInit {
  tabGroupIndex: number = 0
  mode: string = 'all'
  totemPainelMode: string = 'all'
  totemPaineis: Array<TotemPainelType> = []
  totemPainel: TotemPainelType = {}
  totems: Array<TotemType> = []
  totem: TotemType = {}
  tempPainelTotem: Array<TotemPainelType> = []
  paineis: Array<PainelType> = []
  showSpinner: boolean = false
  public formTotem!: FormGroup
  public formTotemPainel!: FormGroup
  public appearanceEnabled: string = 'false'

  public parameters: Array<ParameterType> = []
  public params: Array<string> = [
    'PRIORITY',
    'TOTEM_CALENDAR',
    'TOTEM_PRINTER',
    'TOTEM_SKIP_PATIENT_DATA',
    'MESSAGE_AFTER_CHECKIN',
    'TOTEM_CHECKIN_CHANGES_STATUS',
  ]
  public formSettings: FormGroup
  public parametersResponse: Array<ParameterType> = []

  public prioritarySrc: string = ''
  public birthdateSrc: string = ''

  public columns = [
    {
      columnDef: 'id',
      header: 'ID',
      cell: (element: TotemType) => `${element.id}`,
    },
    {
      columnDef: 'nome',
      header: 'Nome',
      cell: (element: TotemType) => `${element.nome}`,
    },
    {
      columnDef: 'edit',
    },
  ]
  public displayedColumns = this.columns.map((c) => c.columnDef)
  public columnsPainel = [
    {
      columnDef: 'painelnome',
      header: 'Painel',
      cell: (element: TotemPainelType) => `${element.painelnome}`,
    },
    {
      columnDef: 'edit',
    },
  ]
  public displayedColumnsPainel = this.columnsPainel.map((c) => c.columnDef)
  public fileStore: File | null = null
  public setores: any[] = []

  constructor(
    private totemService: TotemPainelService,
    private formBuilder: FormBuilder,
    private parameterService: ParametersService,
    private route: ActivatedRoute,
    private painelService: PainelService,
    private setoresService: SetoresService
  ) {
    this.formSettings = this.formBuilder.group({})

    if (this.parameterService.appearanceEnabled === 'true') {
      this.appearanceEnabled = 'true'

      this.params.push(
        'TOTEM_BACKGROUND_TYPE',
        'TOTEM_BACKGROUND_IMAGE_URL',
        'TOTEM_BACKGROUND_IMAGE_NAME',
        'TOTEM_BACKGROUND_COLOR_PRIMARY',
        'TOTEM_BACKGROUND_COLOR_SECONDARY',
        'TEXT_COLOR'
      )
    }

    this.createTotemSettingsForm()
    this.parametersResponse = this.route.snapshot.data['params']
    this.parameterService.getVarSys('USAR_LOCAL').subscribe((varSys) => {
      let aux = varSys[0]
      aux.chave = aux.param
      aux.valor = aux.value
      this.parametersResponse.push(aux)
    })
  }

  ngOnInit(): void {
    this.setoresService.getSetores().subscribe((setores: any[]) => {
      this.setores = setores
    })

    setTimeout(() => {
      this.parametersResponse.forEach((item: ParameterType) => {
        const control = this.formSettings.get(item.chave!)
        if (control) {
          control.setValue(item.valor)
        }
      })
      this.prioritaryChange()
      this.birthdateChange()
    }, 1000)
  }

  createTotemSettingsForm() {
    this.params.forEach((element) => {
      this.formSettings.addControl(element, new FormControl())
    })
  }

  submitTotemSettingsForm() {
    this.showSpinner = true
    this.parameterService.updateParams(this.formSettings.value)
    setTimeout(() => {
      this.showSpinner = false
      //   window.location.reload()
    }, 2000)
  }

  testPrint() {
    fetch(`http://localhost:8080/imprimir/teste`)
  }

  setTotem(i: number) {
    this.totem = this.totems[i]
    this.totemService.getTotemPaineis(this.totem.id!).subscribe((resp) => {
      this.totemPaineis = resp
      this.totem.paineis = []
      resp.forEach((element: { painelid: number }) => {
        this.totem.paineis?.push(element.painelid)
      })
      this.setForm()
    })
  }

  prioritaryChange() {
    const priority = this.formSettings.get('PRIORITY')?.value

    function getPrioritarySrc() {
      if (priority === 'true') return '../../../assets/images/settingstest/prioritario.jpg'
      if (priority === 'false') return '../../../assets/images/settingstest/not-prioritario.jpg'
      return
    }
    this.prioritarySrc = getPrioritarySrc() || ''
  }

  birthdateChange() {
    const totemCalender = this.formSettings.get('TOTEM_CALENDAR')?.value

    function getBirthdateSrc() {
      if (totemCalender === 'both') return '../../../assets/images/settingstest/ambos.jpg'
      if (totemCalender === 'input') return '../../../assets/images/settingstest/input.jpg'
      if (totemCalender === 'calendar') return '../../../assets/images/settingstest/calendario.jpg'
      return
    }
    this.birthdateSrc = getBirthdateSrc() || ''
  }

  setForm() {
    if (this.formTotem) {
      this.formTotem.controls['id'].setValue(this.totem.id ? this.totem.id : null)
      this.formTotem.controls['nome'].setValue(this.totem.nome ? this.totem.nome : null)
    }
  }

  handleFileInputChange(files: FileList | null): void {
    if (files?.length) {
      const file = files[0]
      this.fileStore = file
      this.formSettings.get('TOTEM_BACKGROUND_IMAGE_NAME')?.setValue(file.name)
      this.handleSubmit()
    } else {
      this.fileStore = null
      console.log('Error uploading the file')
    }
  }

  handleSubmit(): void {
    if (this.fileStore) {
      const formData = new FormData()
      formData.append('upload', this.fileStore, this.fileStore.name)

      this.parameterService.uploadFile(formData).subscribe(
        (response) => {
          this.formSettings.get('TOTEM_BACKGROUND_IMAGE_URL')?.setValue(response.url)
        },
        (error) => {
          console.error('Error submitting file:', error)
        }
      )
    } else {
      console.log('No file selected.')
    }
  }

  onColorChange(event: Event, field: string): void {
    const input = event.target as HTMLInputElement
    const newValue = input.value

    if (/^#[0-9A-Fa-f]{6}$/.test(newValue)) {
      this.formSettings.get(field)?.setValue(newValue, { emitEvent: false })
    }
  }

  restoreAppearance() {
    this.formSettings.get('TOTEM_BACKGROUND_TYPE')?.setValue('gradient')
    this.formSettings.get('TOTEM_BACKGROUND_IMAGE_NAME')?.setValue('totem-background.png')
    this.formSettings
      .get('TOTEM_BACKGROUND_IMAGE_URL')
      ?.setValue('assets/images/totem/totem-background.png')
    this.formSettings.get('TOTEM_BACKGROUND_COLOR_PRIMARY')?.setValue('#6cd8f1')
    this.formSettings.get('TOTEM_BACKGROUND_COLOR_SECONDARY')?.setValue('#244954')
    this.formSettings.get('TEXT_COLOR')?.setValue('#0f0f0f')
  }
}
